import React, { useState, useEffect, useRef } from 'react';
import { Container } from './styles';
import Api, { exceptionNotificationAPI } from '../../services/api';
import TableLoading from '../../components/TableLoading/index';

const ExportAllUsers = () => {

    const [loading, setLoading] = useState(false);
    const [send, setSend] = useState(false);

    const sendExport = () => {
        setSend(true);
        setLoading(true);

        Api.post(`Export/GetUsersExport`, {}, { responseType: 'blob' })
            .then((response) => {
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // Internet Explorer
                    window.navigator.msSaveBlob(response.data, "Export_AllUsers.xlsx");
                } else {
                    // Outros navegadores
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Export_AllUsers.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }

                setLoading(false);
                setSend(false);
            })
            .catch((error) => {
                exceptionNotificationAPI(error);
                setLoading(false);
            });
    }

    return (
        loading ? <Container className='container'>  {send && <div className="mt-2"><TableLoading /></div>} </Container> :
            <Container className="container">
                <div className="col-12 pl-0 pr-0 mt-4">
                    <button className="col-md-12 apply-btn" onClick={() => sendExport()}>Export</button>
                </div>
            </Container>
    );
}

export default ExportAllUsers;
